/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamUser,
    IamUserFromJSON,
    IamUserFromJSONTyped,
    IamUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetIamUserResponse
 */
export interface GetIamUserResponse {
    /**
     * 
     * @type {IamUser}
     * @memberof GetIamUserResponse
     */
    iamUser?: IamUser;
}

export function GetIamUserResponseFromJSON(json: any): GetIamUserResponse {
    return GetIamUserResponseFromJSONTyped(json, false);
}

export function GetIamUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIamUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUser': !exists(json, 'iam_user') ? undefined : IamUserFromJSON(json['iam_user']),
    };
}

export function GetIamUserResponseToJSON(value?: GetIamUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user': IamUserToJSON(value.iamUser),
    };
}


